'use client';

import { useNavigation } from '@/components/navigation/navigation-context';
import { useIsMobile } from '@/lib/is-mobile';

export function useBottomPosition() {
  const isMobile = useIsMobile();
  const { isNavigationVisible, navigationHeight } = useNavigation();

  let bottomPosition = 'env(safe-area-inset-bottom)';

  if (isMobile && isNavigationVisible) {
    bottomPosition = `calc(env(safe-area-inset-bottom) + ${navigationHeight}px)`;
  }

  return { bottomPosition, isMobile };
}
